import { uploadTypeConfigMap } from 'constants/bulkUpload';
import { useSearchParams } from 'hooks/useSearchParams';

export const useBulkUploadType = () => {
  const { urlParams } = useSearchParams<'type'>();

  const bulkUploadType = parseInt(
    urlParams.get('type') || '-1',
  ) as keyof typeof uploadTypeConfigMap;

  return bulkUploadType;
};
